import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { persistAcquisitionAttributionFromUrl } from "utils/readAcquisitionAttribution";

export const AcquisitionAttributionTracker = () => {
  const location = useLocation();

  useEffect(() => {
    persistAcquisitionAttributionFromUrl();
  }, [location.pathname, location.search]);

  return null;
};
